export enum AutomaticStatusWaiting {
  BEFORE_FLAIR_UPLOAD = 'before_flair_upload',
  FLAIR_UPLOADED = 'flair_uploaded',
  BEFORE_STREAMED_UPLOAD = 'before_streamed_upload',
  STREAMED_UPLOADED = 'streamed_uploaded',
  BEFORE_OCR_UPLOAD = 'before_ocr_upload',
  OCR_UPLOADED = 'ocr_uploaded',
}

export enum TimestampStatusCreating {
  CREATING = 'creating',
}
